import { Api } from '@beautybox/core/api';

/** Инициализация модуля запросов */
let provider;
export function init(config) {
    provider = new Api(config.BASE_URL, 'crm', config.token, false);
}

const state = () => ({
    subscriptions: [],
    load: true,
});

const mutations = {
    SET_SUBSCRIPTIONS(state, payload) {
        state.subscriptions = [...payload];
    },
    SET_LOAD(state, payload) {
        state.load = payload;
    },
};
const actions = {
    async GET_SUBSCRIPTIONS({ commit }) {
        commit('SET_LOAD', true);
        const subscriptions = await provider.get('/subscriptions?skip=0&take=15');
        commit('SET_SUBSCRIPTIONS', subscriptions);
        commit('SET_LOAD', false);
    },
};
const getters = {};

export default { init, state, mutations, actions, getters };
